import { render, staticRenderFns } from "./TableImageComponent.vue?vue&type=template&id=c5bdb6c4&scoped=true&"
import script from "./TableImageComponent.vue?vue&type=script&lang=js&"
export * from "./TableImageComponent.vue?vue&type=script&lang=js&"
import style0 from "./TableImageComponent.vue?vue&type=style&index=0&id=c5bdb6c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bdb6c4",
  null
  
)

export default component.exports